import type { Product } from '../../../data/product';
import { formatDate, formatDateISO } from '../../../helpers/format-date';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

// The clock is read per call rather than captured once at module load — see the
// note on LastSold in ./last-sold-column.tsx.
export const LastReceived: StrictColumnDef<Product> = defineColumn<Product>({
  id: "Last Rec'd",
  minWidth: 60,
  accessorFn: (product) =>
    product.last_received ? formatDate(product.last_received, new Date()) : ' -',
  sortKeyFn: (product) => product.last_received,
  toCSV: (product) => ({
    'Last Received': product.last_received ? formatDateISO(product.last_received) : '',
  }),
  gloss: 'Date this item was last received from a vendor.',
});
